import { urlPerfix } from './env'
import { getStore, setStore } from '../config/storage'
import 'whatwg-fetch'
import store from '@/store/store'
import { MessageBox } from 'element-ui';
import { stringToBase64 } from '../util/index'

var tokenExpired = false

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
	type = type.toUpperCase();
	if (url.indexOf('http') == -1) {
		url = urlPerfix + url;
	}
	let userInfo = getStore('costUserInfo');
	let token = ""
	if (userInfo) {
		token = userInfo.token
	}
	let token_validate = data.token_validate == false ? data.token_validate : true
	if (token_validate && (!token || tokenExpired)) {
		store.commit("loginRedirect", window.location.href)
		window.location.href = '/login'
		return
	}

	if (type == 'GET') {
		data.t = new Date().getTime()
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
	}

	url = encodeURI(url)

	let requestConfig = {
		method: type,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Token': token,
		},
		mode: "cors"
	}

	if (type == 'POST' || type == 'PUT') {
		data = {
			base64_body: stringToBase64(JSON.stringify(data))
		}
		Object.defineProperty(requestConfig, 'body', {
			value: JSON.stringify(data)
		})
	}

	try {
		let response = await fetch(url, requestConfig);
		let responseJson = await response.json();

		if (responseJson.code == -3) {
			if (responseJson.data.auth_codes) {
				userInfo.auth_codes = responseJson.data.auth_codes
				userInfo.is_super_admin = responseJson.data.is_super_admin
				userInfo.departments = responseJson.data.departments
				setStore('costUserInfo', userInfo)
				window.location.reload()
			} else if (responseJson.data.token) {
				userInfo.token = responseJson.data.token
				setStore('costUserInfo', userInfo)

				requestConfig.headers.Token = responseJson.data.token
				response = await fetch(url, requestConfig);
				responseJson = await response.json();
				return responseJson
			} else {
				tokenExpired = true
				setStore('costUserInfo', '');
				window.location.href = '/login'
			}
			return
		}

		if (responseJson.code == -1 || responseJson.code == -2) {
			tokenExpired = true
			setStore('costUserInfo', '');
			window.location.href = '/login'
			return
		}

		if (responseJson.code == -4) {
			tokenExpired = true
			setStore('costUserInfo', '');
			window.location.href = `/login?msg=${responseJson.message}`
			return
		}


		if (responseJson.code != 0) {
			alert(responseJson.message)
		}

		return responseJson
	} catch (error) {
		throw new Error(error)
	}
}